// extracted by mini-css-extract-plugin
export default {"wrapper":"footer_wrapper__0ZZoX","container":"footer_container__hP9JV","size_image":"footer_size_image__K4HTR","text":"footer_text__VZ48d","content":"footer_content__J161U"};